import { Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import { PostItem } from '@apps/api-interfaces';

@Pipe({
  name: 'perProduct'
})
export class AlertPerProductPipe implements PipeTransform {

  get promo_fotowoltaika(): boolean {
    return this.router.url.indexOf('/fotowoltaika') > -1;
  }

  get promo_prad(): boolean {
    return this.router.url.indexOf('/prad') > -1;
  }

  get promo_gaz(): boolean {
    return this.router.url.indexOf('/gaz') > -1;
  }

  constructor(private router: Router) {}

  public transform(items: PostItem[]): any[] {
    if (!items || !items.length) {
      return items;
    }

    return items.filter(e => this[e.extra2]);
  }
}
